import { useEffect, useState } from 'react';

const useWindowHeight = () => {
  const [innerHeight, setInnerHeight] = useState(0);
  useEffect(() => {
    setInnerHeight(window.innerHeight);
  }, []);

  return { height: innerHeight ? `${innerHeight}px` : '100vh', innerHeight };
};

export default useWindowHeight;
